import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { labExperiments } from "@/data/skills";

export function EngineeringLab() {
  return (
    <section id="lab" className="container-x section-y" data-testid="lab-section">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="eyebrow">06 — ENGINEERING LAB</p>
          <h2 className="font-display mt-8 max-w-3xl text-[clamp(2rem,4.5vw,4rem)] font-semibold uppercase leading-[1.02] tracking-tight">
            WHERE SOFTWARE <span className="text-outline">MEETS AI</span>
          </h2>
        </div>
        <p className="max-w-xs text-sm leading-relaxed text-muted">Experiments at the intersection of software engineering and AI.</p>
      </div>

      <div className="mt-16 grid gap-px border border-line bg-line sm:grid-cols-2 lg:grid-cols-3" data-testid="lab-grid">
        {labExperiments.map((exp, i) => {
          const Icon = exp.icon;
          return (
            <motion.article
              key={exp.title}
              className="group relative bg-background"
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              whileHover={{ scale: 1.02, y: -4 }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`lab-card-${exp.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <div className="flex items-start justify-between">
                <span className="text-accent transition-transform duration-300 group-hover:-rotate-6 group-hover:translate-x-0.5">
                  <Icon size={22} aria-hidden="true" />
                </span>
                <ArrowUpRight
                  size={16}
                  className="text-muted transition-all duration-500 group-hover:-translate-y-1 group-hover:translate-x-1"
                  aria-hidden="true"
                />
              </div>
              <h3 className="font-display mt-14 text-lg font-semibold tracking-tight">{exp.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted">{exp.description}</p>
              <span
                className="absolute left-0 top-0 h-full w-px origin-top scale-y-0 transition-transform duration-500 group-hover:scale-y-100"
                style={{ backgroundColor: "var(--accent)" }}
                aria-hidden="true"
              />
            </motion.article>
          );
        })}
      </div>
    </section>
  );
}
